import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { OverflowText } from '../OverflowText';

function InfoItemContent({ content, parentIndex }) {
  if (Array.isArray(content)) {
    return (
      <Stack spacing={0.5} key={`businessProfileItemContent-${parentIndex}`}>
        {content.map((item, index) => (
          <OverflowText key={`businessProfileItemContent-${parentIndex}-${index.toString()}`}>{item}</OverflowText>
        ))}
      </Stack>
    );
  }

  return <OverflowText key={`businessProfileItemContent-${parentIndex}`}>{content}</OverflowText>;
}

InfoItemContent.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  parentIndex: PropTypes.number.isRequired,
};

function InfoItem({ title, items }) {
  return (
    <Stack spacing={0.5}>
      <Text size="xs" textTransform="uppercase" color="secondary">
        {title}
      </Text>
      <Stack spacing={2}>
        {items.map(({ content }, index) => (
          <InfoItemContent key={`businessProfileItem-${index.toString()}`} content={content} parentIndex={index} />
        ))}
      </Stack>
    </Stack>
  );
}

InfoItem.propTypes = {
  title: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
  ).isRequired,
};

export default InfoItem;
